<template>
  <div class="bmxx">
    <el-tabs v-model="activeName">
      <el-tab-pane label="调动记录" name="distributiont" />
    </el-tabs>
    <distributiont v-if="activeName==='distributiont'" />
  </div>
</template>

<script>
import distributiont from '@/views/departmentStat/operationStat/components/main/bdjl/distributiont'

export default {
  components: {
    distributiont,
  },
  data() {
    return {
      activeName: 'distributiont',
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-tabs {
    &__nav-wrap::after {
      display: none;
    }
    &__item {
      padding: 5px 10px;
      margin: 0 2px;
      height: auto;
      line-height: 1.5;
      border-radius: 8px;
      &.is-active {
        color: #0079fe;
        background-color: #b3d7ff;
      }
    }
    &__active-bar {
      display: none;
    }
  }
  .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2),
  .el-tabs--bottom .el-tabs__item.is-top:nth-child(2),
  .el-tabs--top .el-tabs__item.is-bottom:nth-child(2),
  .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 10px;
    margin-left: 0;
  }
  .el-tabs--bottom .el-tabs__item.is-bottom:last-child,
  .el-tabs--bottom .el-tabs__item.is-top:last-child,
  .el-tabs--top .el-tabs__item.is-bottom:last-child,
  .el-tabs--top .el-tabs__item.is-top:last-child {
    padding-right: 10px;
    margin-right: 0;
  }
}
.bmxx {
  display: flex;
  flex-flow: column;
  height: calc(100% - 54px);
  > .basic-container {
    flex: 1;
  }
}
::v-deep {
  .avue-crud {
    display: flex;
    flex-flow: column;
    flex: 1;
  }
  .el-table thead.is-group th {
    background-color: #40a9ff;
    color: #fff;
  }
}
::v-deep {
  .avue-crud__menu {
    display: none;
  }
}
</style>
